import React, { useEffect, useState,useRef } from "react";
// api services
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
// data select
import { AreaOptions } from "../../../../../utils/dataSelectOptions";
// models
import {
  initialValuesConvocatoriasBEPSModel,
  ConvocatoriasBEPSModel,
} from "../../../../../models/ConvocatoriasBepsModel/convocatoriasbeps.model";

import { useEncrypt } from "../../../../../hooks/useEncrypt";
import getStorageUser from "../../../../../middlewares/GetStorageUser"
import DocumentosService  from "../../../../../api/Documentos/api-documentos";
import { openNotification } from "../../../../../utils/saveFile";


export const useCrearConvocatoria = () => {
  // redux
  const { decrypt, encrypt } = useEncrypt();
  const editar_convocatoria = decrypt(localStorage.getItem("editar_convocatoria"));
  let editarConvocatoria = false;
  if(editar_convocatoria !== null){
    editarConvocatoria = Boolean(editar_convocatoria)
  }

  const  idConvocatoria  = decrypt(localStorage.getItem("id_convocatoria"));

  const [user, setUser] = useState<any>({})
  const getUser = async () => {
    try {
      const user = getStorageUser()
      setUser(user)
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getUser()
    
  }, [])

  // state
  const [convocatoriabeps, setConvocatoriasBeps] = useState<ConvocatoriasBEPSModel>(
    initialValuesConvocatoriasBEPSModel
  );
  // functions
  const cargarConvocatoriasBeps = async () => {
    let data = await apiConvocatorias.obtenerConvocatoriasBeps();
    setConvocatoriasBeps(data.data);
  };
  const guardarycontinuar = async (cambiarPestaña: any) => {
    
    let infoupdate : any = { ...convocatoriabeps };
    let categoriasnuevas = infoupdate.area.map((data: any, index: number) => {
      let existe = AreaOptions.filter((x: any, i: number) => x.value === data);
      if (existe.length > 0) {
        return {
          value: existe[0].value,
          text: existe[0].value,
        };
      }
      return data;
    });
    infoupdate.area = categoriasnuevas;
    infoupdate.tipo_participante = [{ value: 1, text: "Persona natural" }];
    infoupdate.tipo = 3;
    infoupdate.usuario_creacion = `${user.nombres} ${user.apellidos}`

    if (editarConvocatoria) {
      try {
        let data = await apiConvocatorias.editarConvocatoriasBeps(infoupdate, idConvocatoria);
        localStorage.setItem('cambiarPestaña', encrypt("2"))
        return cambiarPestaña("2");
      } catch (error) {
        return console.error(error);
      }
    }
    try {
      let data = await apiConvocatorias.guardarConvocatoriaBeps(infoupdate);
      await localStorage.setItem('id_convocatoria', encrypt(data.data.data.idconvocatorias.toString()));  
      localStorage.setItem('cambiarPestaña', encrypt("2"))
      return cambiarPestaña("2");
    } catch (error) {
      return console.error(error);
    }
  };
  const handleChange = async (value: any, name: string) => {
    let infoupdate = { ...convocatoriabeps };
    infoupdate[name] = value;
    return setConvocatoriasBeps(infoupdate);
}
const [portada, setPortada] =  useState<any>("");
const fileInputRef = useRef<any>();
const [guardoArchivo, setGuardoArchivo] = useState(false);
const guardarArchivo = async (e: any) => {
  if (e.target.files.length > 0) {
    if (e.target.files[0].size > 5000000) {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos menores a 5MB",
        placement: "bottomRight",
      });
    }
    if (
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpeg"
    ) {
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return setPortada(data.data);
    }
    openNotification({
      titulo: "Error",
      descripcion: "Solo se permiten archivos Png y Jpg",
      placement: "bottomRight",
    });
    return setPortada("");
  }
};
  return { 
    convocatoriabeps, 
    setConvocatoriasBeps, 
    cargarConvocatoriasBeps, 
    guardarycontinuar, 
    guardarArchivo,
    guardoArchivo,
    setGuardoArchivo,
    handleChange,
    setPortada,
    portada,
    fileInputRef
  };
};
